import { render, staticRenderFns } from "./CenterViewFirstTimeFreeUpload_Ap.vue?vue&type=template&id=ffc529ca&scoped=true"
import script from "./CenterViewFirstTimeFreeUpload_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewFirstTimeFreeUpload_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewFirstTimeFreeUpload_Ap.vue?vue&type=style&index=0&id=ffc529ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc529ca",
  null
  
)

export default component.exports